import styled from 'styled-components';

export const Container = styled.div`
	background-color: #f9fafb;
	color: #374151;
`;

export const Section = styled.div`
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
	background-color: #ffffff;
	border-radius: 8px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	margin-bottom: 40px;
`;

export const Title = styled.h2`
	font-size: 28px;
	font-weight: bold;
	color: #1f2937;
	margin-bottom: 16px;
`;

export const List = styled.ul`
	list-style: none;
	padding: 0;
`;

export const ListItem = styled.li`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	border-bottom: 1px solid #e5e7eb;
	background-color: #f3f4f6;
	cursor: pointer;
	transition: background-color 0.2s;
	font-size: 16px;

	&:hover {
		background-color: #e5e7eb;
	}
`;

export const Arrow = styled.span`
	color: #9ca3af;
	font-size: 16px;
`;

export const BackButton = styled.button`
	display: flex;
	align-items: center;
	font-size: 16px;
	color: #3b82f6;
	background: transparent;
	border: none;
	cursor: pointer;
	padding: 4px 8px;
	transition: color 0.2s;
	margin-bottom: 20px;

	&:hover {
		color: #2563eb;
	}

	svg {
		margin-right: 4px;
	}
`;

export const RepoLink = styled.a`
	font-size: 16px;
	color: #3b82f6;
	text-decoration: none;
	margin-bottom: 16px;
	display: block;

	&:hover {
		text-decoration: underline;
	}
`;

export const LicenseText = styled.pre`
	font-size: 14px;
	color: #374151;
	white-space: pre-wrap;
	line-height: 1.6;
	width: 100%;
	overflow-wrap: break-word;
	word-wrap: break-word;
`;

export const LicenseSection = styled.div`
	padding: 20px;
	background-color: transparent;
	border-radius: 0;
	box-shadow: none;
	max-width: 100%;
	margin: 20px 0;
	width: 100%;
	overflow-wrap: break-word;
`;

export const PlatformSelect = styled.select`
	padding: 8px;
	font-size: 16px;
	border-radius: 4px;
	border: 1px solid #ccc;
	background-color: white;
	cursor: pointer;
	color: #374151;

	&:hover {
		border-color: #9ca3af;
	}

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
	}
`;

export const SelectContainer = styled.div`
	width: 100%;
	background-color: #f9fafb;
	border-top: 1px solid #e5e7eb;
	border-bottom: 1px solid #e5e7eb;
	margin-bottom: 40px;
`;

export const PlatformTabs = styled.div`
	max-width: 800px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	gap: 32px;
`;

export const PlatformTab = styled.button<{ isActive: boolean }>`
	padding: 12px 8px;
	min-width: 120px;
	font-size: 16px;
	font-weight: 500;
	background: none;
	border: none;
	cursor: pointer;
	color: ${props => (props.isActive ? '#3b82f6' : '#6b7280')};
	border-bottom: 2px solid
		${props => (props.isActive ? '#3b82f6' : 'transparent')};
	transition: all 0.2s;

	&:hover {
		color: #3b82f6;
		background-color: rgba(59, 130, 246, 0.05);
	}
`;
